import { useState } from "react";
import { decryptData, fmt } from "../components/const";
import UseFetch from "../components/UseFetch";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Select from "react-select";

const exportPDF = (clients, magasin, total) => {
    const doc = new jsPDF('landscape');
    const date = new Date().toLocaleDateString('fr-FR');

    doc.setFontSize(14);
    doc.text(`Magasin : ${magasin ?? ''}`, 14, 15);
    doc.setFontSize(11);
    doc.text(`Clients en dette — ${date}`, 14, 23);
    doc.setTextColor(180, 0, 0);
    doc.text(`Total des dettes : ${fmt(total)} GNF`, 14, 30);
    doc.setTextColor(0, 0, 0);

    autoTable(doc, {
        startY: 35,
        head: [['N°', 'Client', 'Téléphone', 'Adresse', 'Agent', 'Magasin', 'Dette initiale', 'Dette facture', 'Total dette']],
        body: clients.map((c, i) => [
            i + 1,
            c.nom_client,
            c.telephone,
            c.adresse,
            c.agent,
            c.magasin,
            `${fmt(c.dette_initiale)} `,
            `${fmt(c.dette_facture)} `,
            `${fmt(c.total_dette)} `,
        ]),
        styles: { fontSize: 8, lineWidth: 0.2, lineColor: [0, 0, 0] },
        headStyles: { fillColor: [13, 110, 253] },
        theme: 'grid',
        // couleurs des bordures bleues
        alternateRowStyles: { fillColor: [240, 248, 255] },
    });

    doc.save(`clients_en_dette_${magasin ?? 'export'}.pdf`);
};

const ClientsEnDette = () => {
    const profile = decryptData('user_profile');
    const { data, isloading } = UseFetch(`client-en-dette`);
    const [selectedMagasin, setSelectedMagasin] = useState(null);

    const magasinOptions = [
        { value: null, label: 'Tous les magasins' },
        ...([...new Set((data ?? []).map(c => c.magasin).filter(Boolean))])
            .map(m => ({ value: m, label: m }))
    ];

    const filtered = (data ?? []).filter(c =>
        !selectedMagasin?.value || c.magasin === selectedMagasin.value
    );
    const total = filtered.reduce((sum, c) => sum + c.total_dette, 0);
    return (
        <div className="container-fluid py-3">
            {isloading ? (
                <div className="loader"></div>
            ) : data?.length ? (
                <>
                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                        <div>
                            <h4 className="text-primary mb-0">Clients en dette</h4>
                            <span className="text-danger fw-bold">
                                Total : {fmt(total)} GNF
                                <span className="text-muted fw-normal ms-2">({filtered.length} client{filtered.length > 1 ? 's' : ''})</span>
                            </span>
                        </div>
                        <div className="d-flex gap-2 align-items-center flex-wrap">
                            <Select
                                options={magasinOptions}
                                value={selectedMagasin}
                                onChange={setSelectedMagasin}
                                placeholder="Filtrer par magasin..."
                                isClearable
                                styles={{ container: base => ({ ...base, minWidth: 220 }) }}
                            />
                            <button className="btn btn-danger text-nowrap" onClick={() => exportPDF(filtered, selectedMagasin?.label ?? "Tous les magasins", total)}>
                                Exporter PDF
                            </button>
                        </div>
                    </div>

                    <div key={selectedMagasin?.value ?? 'all'} className="table-responsive">
                        <table className="table table-hover table-striped table-bordered align-middle">
                            <thead className="table-primary">
                                <tr>
                                    <th>N°</th>
                                    <th>Client</th>
                                    <th>Téléphone</th>
                                    <th>Adresse</th>
                                    <th>Agent</th>
                                    <th>Magasin</th>
                                    <th>Dette initiale</th>
                                    <th>Dette facture</th>
                                    <th>Total dette</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.length > 0 ? filtered.map((c, i) => (
                                    <tr key={c.id}>
                                        <td>{i + 1}</td>
                                        <td className="fw-semibold">{c.nom_client}</td>
                                        <td>{c.telephone}</td>
                                        <td>{c.adresse}</td>
                                        <td>{c.agent}</td>
                                        <td>{c.magasin}</td>
                                        <td>{fmt(c.dette_initiale)} GNF</td>
                                        <td>{fmt(c.dette_facture)} GNF</td>
                                        <td className="fw-bold text-danger">{fmt(c.total_dette)} GNF</td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan={8} className="text-center text-muted py-3">Aucun résultat pour </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                <div className="p-3 text-center text-danger bg-danger-subtle rounded">Aucun client en dette</div>
            )}
        </div>
    );
};

export default ClientsEnDette;
